module.exports = __webpack_public_path__ + "img/2025-03-14-02-01.fac35ec3.png";